export default {"src":"/_next/static/media/WMT.80ec2dbf.svg","height":18,"width":18};